
import {defineComponent, type PropType} from "vue";

interface InlinePromiseVisual {
    id?: string | number;
    url: string;
    alt?: string;
}

interface InlinePromiseAttribute {
    title?: string;
    text?: string;
    titleHtml?: string;
    textHtml?: string;
}

interface InlinePromiseClaim {
    visuals?: InlinePromiseVisual[];
    image?: InlinePromiseVisual;
    attributes?: InlinePromiseAttribute | InlinePromiseAttribute[];
}

interface InlinePromiseContentRow {
    title: string;
    text: string;
}

export default defineComponent({
    name: "InlinePromise",
    props: {
        claim: {
            type: Object as PropType<InlinePromiseClaim>,
            required: true,
        },
        isBlack: {
            type: Boolean,
            default: false,
        },
        isWarning: {
            type: Boolean,
            default: false,
        },
        compactText: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        visuals(): InlinePromiseVisual[] {
            if (Array.isArray(this.claim.visuals) && this.claim.visuals.length > 0) {
                return this.claim.visuals;
            }
            if (this.claim.image && this.claim.image.url) {
                return [this.claim.image];
            }
            return [];
        },
        attributes(): InlinePromiseAttribute[] {
            if (Array.isArray(this.claim.attributes)) {
                return this.claim.attributes;
            }
            if (this.claim.attributes && typeof this.claim.attributes === "object") {
                return [this.claim.attributes];
            }
            return [];
        },
        contentRows(): InlinePromiseContentRow[] {
            return this.attributes
                .map((attribute): InlinePromiseContentRow | null => {
                    if (!attribute) {
                        return null;
                    }

                    const title = attribute.titleHtml || attribute.title || "";
                    const text = attribute.textHtml || attribute.text || "";

                    return title || text ? {title, text} : null;
                })
                .filter((row): row is InlinePromiseContentRow => row !== null);
        },
    },
});
